import { Component } from '@angular/core';
import { BankBaseTabPageComponent } from '../bank-base-tab-page.component';

@Component({
  selector: 'bank-addresses',
  standalone: true,
  imports: [],
  templateUrl: './bank-addresses.component.html',
  styleUrl: './bank-addresses.component.less'
})
export class BankAddressesComponent extends BankBaseTabPageComponent {
}
